import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {BannerTypesEnum} from '../../../../../libs/shared/core/src/store/banners/commonBannerState';
import {MacrosBannerState} from '../../../../store/panels/app/banners/bannersState';
import {MacrosErrorBanner} from './macrosErrorBanner';
import {MacrosSuccessBanner} from './macrosSuccessBanner';

/*
 * Props.
 */

interface MacrosBannersProps {
  banners: ReadonlyArray<MacrosBannerState>;
  onClose: (bannerUid: string) => void;
}

/*
 * Component.
 */
// In the future with more banner types we can add a switch or something to render different types of banners
export const MacrosBanners: FC<MacrosBannersProps> = ({banners, onClose}) =>
  banners.map((banner) => {
    switch (banner.type) {
      case BannerTypesEnum.SUCCESS:
        return (
          <MacrosSuccessBanner
            key={banner.uid}
            macroExecutionInfo={banner.macroExecutionInfo}
            onDismissClick={() => onClose(banner.uid)}
          />
        );
      case BannerTypesEnum.ERROR:
        return (
          <MacrosErrorBanner
            key={banner.uid}
            name={banner.name}
            errorMessage={
              banner.macrosError ?? (
                <Trans id="macros-error-banner-default-error">Please try again later.</Trans>
              )
            }
            onDismissClick={() => onClose(banner.uid)}
          />
        );
      default:
        return null;
    }
  });
